/** QL-375 — the per-portfolio verdict list (group 7). Read with `useT(T)`. */
export const T = {
  en_GB: {
    // Decision box (screens 02 / 03)
    acceptedByName: (name: string) => `Accepted by ${name}`,
    blockedByName: (name: string) => `Blocked by ${name}`,
    // Group 7 — portfolio-level blocking and Update from portfolio (screen 07)
    portfolioVerdictsTitle: "By portfolio",
  },
  nb_NO: {
    acceptedByName: (name: string) => `Akseptert av ${name}`,
    blockedByName: (name: string) => `Blokkert av ${name}`,
    portfolioVerdictsTitle: "Per portefølje",
  },
} as const;
